import { render, staticRenderFns } from "./index.vue?vue&type=template&id=d1b76028&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=d1b76028&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1b76028",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\www\\mer\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d1b76028')) {
      api.createRecord('d1b76028', component.options)
    } else {
      api.reload('d1b76028', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=d1b76028&scoped=true", function () {
      api.rerender('d1b76028', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/distribution/alliance/config/index.vue"
export default component.exports